import { db, type ZeitEintragDB } from '../db/schema';

export type { ZeitEintragDB };

export async function addZeitEintrag(e: Omit<ZeitEintragDB, 'erstelltAm'>): Promise<void> {
  await db.zeiteintraege.add({ ...e, erstelltAm: new Date().toISOString() });
}

export async function loadZeiteintraege(mandantId?: string): Promise<ZeitEintragDB[]> {
  if (mandantId !== undefined && mandantId !== '') {
    return db.zeiteintraege.where('mandantId').equals(mandantId).sortBy('datum');
  }
  return db.zeiteintraege.orderBy('datum').toArray();
}

export async function toggleAbgerechnet(id: string): Promise<void> {
  const e = await db.zeiteintraege.get(id);
  if (e !== undefined) {
    await db.zeiteintraege.update(id, { abgerechnet: !e.abgerechnet });
  }
}

export async function updateZeitEintrag(e: ZeitEintragDB): Promise<void> {
  await db.zeiteintraege.put(e);
}

export async function deleteZeitEintrag(id: string): Promise<void> {
  await db.zeiteintraege.delete(id);
}
